import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { widthMixin } from '../mixins';

const FooterContainer = styled.div`
  display: grid;
  width: auto;
  background: #f2f4f7;
  padding: 50px 0 120px 0;
`;

const FooterContent = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-self: center;
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  li {
    margin: 0;
    padding: 0;
  }
  ${widthMixin};
`;

const FooterLink = styled(Link)`
  text-decoration: none;
  color: #444;
`;

export { FooterContainer, FooterContent, FooterLink };



// WEBPACK FOOTER //
// ./src/components/UI/FooterUI.tsx